export enum MultiPersonSearchMessages {
  LABEL = 'Name, ID number or email',
}
